<div class="roi-container">
  <router-outlet></router-outlet>
</div>
